import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { toast } from 'react-toastify';
import { API_ENDPOINTS } from '../apiEndpoints';

function SignIn() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    if (!email || !password) {
      toast.error('Please enter both your email and password.');
      setLoading(false);
      return;
    }
    try {
      const response = await fetch(API_ENDPOINTS.adminLogin, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      let data;
      try {
        data = await response.json();
      } catch (jsonErr) {
        toast.error('Invalid server response. Please try again.');
        setLoading(false);
        return;
      }
      if (response.ok && data.data && data.data.access_token) {
        login(data.data.access_token, data.data); // only store access_token
        toast.success('Login successful! Redirecting...');
        navigate('/dashboard');
        setTimeout(() => {
          window.location.reload();
        }, 3000);
        
      } else if (data && data.message) {
        toast.error(data.message);
      } else {
        toast.error('Login failed. Please check your credentials.');
      }
    } catch (err) {
      toast.error('A network error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sign-inup">
      <div className="container d-flex align-items-center justify-content-center form-height-login pt-24px pb-24px">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-10">
            <div className="card">
              <div className="card-header bg-primary">
                <div className="ec-brand">
                  <a href="#" title="Owena">
                    <img className="ec-brand-icon" src="assets/img/logo/logo-login.png" alt="Owena" />
                  </a>
                </div>
              </div>
              <div className="card-body p-5">
                <h4 className="text-dark mb-5">Sign In</h4>
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="form-group col-md-12 mb-4">
                      <input 
                        type="email" 
                        className="form-control" 
                        id="email" 
                        placeholder="Username"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={loading}
                      />
                    </div>
                    <div className="form-group col-md-12 ">
                      <input 
                        type="password" 
                        className="form-control" 
                        id="password" 
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        disabled={loading}
                      />
                    </div>
                    <div className="col-md-12">
                      <div className="d-flex my-2 justify-content-between">
                        {/* <div className="d-inline-block mr-3">
                          <p><a className="text-blue" href="#">Forgot Password?</a></p>

                           <div className="control control-checkbox">Remember me
                            <input type="checkbox" />
                            <div className="control-indicator"></div>
                          </div> 
                        </div>*/}
                      </div>
                      <button 
                        type="submit" 
                        className="btn btn-primary btn-block mb-4"
                        disabled={loading}
                      >
                        {loading ? 'Signing In...' : 'Sign In'}
                      </button>
                      <p className="sign-upp">Forgot password ?
                        <a className="text-blue" href="#"> Get New Password</a>
                      </p>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignIn;